package com.example.mystybag.core.extensions

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import dev.icerock.moko.resources.ColorResource
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.ResourceContainer
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.getImageByFileName
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.resources.SRC

/** StringResource Ext */
val ResourceContainer<StringResource>.weekdays: List<StringResource>
    get() = listOf(
        SR.strings.weekday_sunday,
        SR.strings.weekday_monday,
        SR.strings.weekday_tuesday,
        SR.strings.weekday_wednesday,
        SR.strings.weekday_thursday,
        SR.strings.weekday_friday,
        SR.strings.weekday_saturday
    )

/** ImageResource Ext */
fun ResourceContainer<ImageResource>.getCircleCurrencyFlag(currency: String) : ImageResource? {
    return SRC.images.getImageByFileName("${currency.lowercase()}_circle_flag")
}

/** Връща ImageResource за флаг на държава по ISO 3166-1 alpha-2 код (напр. "BG"). Ако няма файл, връща null. */
fun ResourceContainer<ImageResource>.getCountryFlag(isoAlpha2: String): ImageResource? {
    if (isoAlpha2.length != 2) return null
    return SRC.images.getImageByFileName("${isoAlpha2.lowercase()}_flag")
}

/** ColorResource Ext */
val ColorResource.color: Color
    @Composable
    get() = colorResource(this)
